<template>
  <div class="target-selector-actions" part="actions">
    <sp-button
      v-for="action in actions"
      :key="action.key"
      variant="appearance-link"
      size="x-small"
      @click="emit('activate', action.key)"
      >{{ action.label }}</sp-button
    >
  </div>
</template>

<script setup>
const emit = defineEmits(["activate"]);

defineProps({
  /**
   * @type {Array<{key: String, label: String}>}
   */
  actions: {
    type: Array,
    default: () => [],
  },
});
</script>

<style lang="scss" scoped>
// The pane's first slotted row is its field label, and the actions sit on that row. The admin label
// has a line height of 1, so a row as tall as the label's font size centres the buttons on it.
.target-selector-actions {
  align-items: center;
  display: flex;
  height: var(--sp-ref-scale-16);
  gap: var(--sp-ref-scale-6);
  justify-content: flex-end;
  position: absolute;
  right: 0;
  top: 0;

  // A link-styled `sp-button` is an inline host, which reserves a full line of the page's line
  // height above the link. As a flex container it is only as tall as the link.
  sp-button {
    display: inline-flex;
  }
}
</style>
